// extracted by mini-css-extract-plugin
export default {"logoPopup":"LogoPopup_logoPopup__Q4eNe"};